import React from 'react';
import { Modal, Header, Button, Label, List, Segment, Icon } from 'semantic-ui-react';


const TriviaReview = props => (
    <Modal centered={false} closeIcon trigger={<Button positive size='small' content='Review trivia with correct answers!' />}>
        <Header icon='chart line' content={`${props.Name} Review`} />
        <Modal.Content scrolling>
            <List divided verticalAlign='middle'>
                {
                    props.Questions.map(question => 
                        <List.Item key={question.title}>
                            <List.Content>
                                <Segment basic>
                                    <Header content={question.title} />
                                        {
                                            question.answers.map(answer => 
                                                answer.isCorrect ?
                                                    <Label key={answer.title} color="green">
                                                        <Icon name='check' />
                                                        {answer.title}
                                                    </Label>
                                                : 
                                                    null
                                            )
                                        }
                                </Segment>
                            </List.Content>
                        </List.Item>
                    )
                }
            </List>
      </Modal.Content>
    </Modal>
)

export default TriviaReview;
